<template>
  <div>
    <div class="pop_update pop_bege popup_wrap" style="display:block">
      <div class="popup_in">
        <div class="popup">
          <div class="popup_close stay_close close-animate">
            <a href="javascript:void(0);" @click.prevent="goHome">
              <close></close>
            </a>
          </div>
          <div class="pop_frame">
            <div class="pop_update-st1" v-if="false">
              <h2 class="title25">
                ההזמנה המעודכנת תיכנס לתוקף
                <br>החל משבוע הבא.
              </h2>
              <!-- <div class="title25">
                <span>ברצונך להמשיך?</span>
              </div>
              <div class="bt_green ease">
                <a href>כן, עדכנו את ההזמנה</a>
              </div>
              <div class="green_link">
                <a href>ביטול</a>
              </div> -->
                 <div class="bt_green ease">
                <a href="javascript:void(0);" @click.prevent="goHome">אישור</a>
              </div>
            </div>
            <div class="pop_update-st2">
              <div class="ok-update">
                <ok/>
              </div>
              <h2 class="title25" >ההזמנה עודכנה בהצלחה!</h2>
              <div class="bt_green ease" >
                <a href="javascript:void(0);" @click.prevent="goHome">אישור</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Close from "../../assets/img/close.svg";
  import Ok from "../../assets/img/ok.svg";
  import { mapState } from "vuex";
  export default {
    methods: {
      goHome() {
        this.$store.commit("clearCart");
        this.$modal.hide("order-update");
        this.$router.push("/");
      }
    },
    computed: {
      ...mapState(["orderEdit", "orderEditMeta","permenantOrderEdit"]),
      isPermenetOrder() {
        if (typeof this.permenantOrderEdit == 'object' && this.permenantOrderEdit) {
          return true;
        }
        return false;
      }
    },
    components: {
      Close,
      Ok
    }
  };
</script>

<style scoped>
</style>